class GiveCodeListing {
      constructor() {
        this.giveCodeId = this.getGiveCodeFromUrl() || false;
        this.formConfig = this.getFormConfigs();
        this.giveCodeCardListing = this.getGiveCodeCardListing();
        this.processGiveCodesDisplay();
    }

    getGiveCodeCardListing() {
        return document.querySelector(".give-code-listing__give-codes");
    }

    async getRegisteredGiveCodes() {
        let registgeredGiveCodesReturn = await fetch(
            this.formConfig.getRegisteredGiveCodesUrl
        )
            .then((response) => response.json())
            .then((data) => {
                return data;
            })
            .catch((e) => {
                throw new Error(e);
            });

        console.log(registgeredGiveCodesReturn);

        return registgeredGiveCodesReturn;
    }

    getGiveCodeFromUrl() {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get("giveID");
    }

    getFormConfigs() {
        try {
            const formSettingsContent = document.getElementById(
                "give-code-listings__settings"
            ).textContent;

            return JSON.parse(formSettingsContent);
        } catch (e) {
            console.log("Error parsing form settings data ");
            console.log(e);
        }
    }

    async updateGiveCode() {
        return await fetch(
            `${this.formConfig.destination}/${this.giveCodeId}`,
            {
                method: "PUT",
                headers: {
                    Accept: "application/json, text/plain, */*",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(this.formConfig.customer),
            }
        )
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((e) => {
                throw new Error(e);
            });
    }

    getGiveCodeCardStrFromData({ trackingProject, giveCode, dateCreated }) {
        let dateParsed = new Date(dateCreated);

        return `
            <div class="give-code-card">
                <div class="give-code-card__content-container">
                    <div class="give-code-card__code" tabindex="0">${giveCode}</div>
                    <div class="give-code-card__date" tabindex="0">
                        ${this.formConfig.dateAddedTextContent}: 
                        ${dateParsed.getMonth() + 1}/${dateParsed.getDate()}/${
            dateParsed.getFullYear() - 2000
        }
                    </div>
                    <div class="give-code-card__link">
                        <a href="${trackingProject}">${
            this.formConfig.linkTextContent
        } ›</a>
                    </div>
                </div>
            </div>
        `;
    }

    async processGiveCodesDisplay() {
        if (!this.formConfig.customer.email) return;

        this.registeredGiveCodes = this.giveCodeId
            ? await this.updateGiveCode()
            : await this.getRegisteredGiveCodes();
        this.updateGiveCodesDisplay();
    }

    updateGiveCodesDisplay() {
        if (!this.registeredGiveCodes.length) return;

        for (let giveCode of this.registeredGiveCodes) {
            let giveCodeCardStr = this.getGiveCodeCardStrFromData(giveCode);
            let giveCodeCard = this.stringToHtml(giveCodeCardStr);
            this.giveCodeCardListing.prepend(giveCodeCard);
        }
    }

    stringToHtml(str) {
        let parser = new DOMParser();
        let doc = parser.parseFromString(str, "text/html");
        return doc.body.firstChild;
    }
}

document.addEventListener("DOMContentLoaded", () => {
    let giveCodeListingEl = document.querySelector("give-code-listing");
    new GiveCodeListing(giveCodeListingEl);
});
